// 个股笔记
import request from '@/utils/request'
import { getwayurl, eduurl } from './config'
import { useRoute } from 'vue-router'
const route = useRoute()
// import { logicalExpression } from '@babel/types';
type dataType = any
export default {
  // 精品课程
  getRecommendCourses(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: getwayurl + '/rjhy-edu-uranus/api/1/school/pc/classroom/recommend/courses',
      method: 'get',
      params: data.data,
      headers: data.headers
    })
  },
  // 精选课程
  getProjectCourse(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: getwayurl + '/rjhy-edu-uranus/api/1/school/group/type/project/get',
      method: 'post',
      data: data.data,
      headers: data.headers
    })
  },
  // 根据专题查询课程列表
  getCourse(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: getwayurl + '/rjhy-edu-uranus/api/1/school/group/type/course/get',
      method: 'get',
      params: data.data,
      headers: data.headers
    })
  },
  // 全部课程
  getAllCourse(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: getwayurl + '/rjhy-edu-uranus/api/1/school/pc/classroom/search/courses',
      method: 'get',
      params: data.data,
      headers: data.headers
    })
  },
  // 搜索课程（请求全量数据后，前端匹配模糊）
  getSearchCourse(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: getwayurl + '/rjhy-edu-uranus/api/1/school/course/subject/all',
      method: 'get',
      params: data.data,
      headers: data.headers
    })
  },
  // 查看全部课程标签及分类
  getGroupType(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: getwayurl + '/rjhy-edu-uranus/api/1/school/group/type/get',
      method: 'get',
      params: data.data,
      headers: data.headers
    })
  },
  // 详情-课程视频地址
  getCourseVideoUrl(data: dataType): Promise<{
    response?: Response
  }> {
    let str = '/rjhy-edu-uranus/api/2/education/pc/course/invest/video/url'
    if (data.softNameAbbr === 'jfzt') {
      str = '/edu/api/2/education/pc/course/invest/video/url'
    }
    return request({
      url: eduurl + str,
      method: 'get',
      params: data.data,
      headers: data.headers
    })
  },
  // 详情-课程详情信息
  getCourseDtail(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: eduurl + '/rjhy-edu-uranus/api/1/subscribe/course/detail',
      method: 'get',
      params: data.data,
      headers: data.headers
    })
  },
  // http://yapi.techgp.cn/mock/280/api/1/school/teacher/course
  getTeacherCourse(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: eduurl + '/rjhy-edu-uranus/api/1/school/teacher/course',
      method: 'get',
      params: data.data,
      headers: data.headers
    })
  }
}
